module.exports = __webpack_public_path__ + "static/media/emailEx.1d85ac5a.png";